import { render, staticRenderFns } from "./outbound.vue?vue&type=template&id=e8bd6ece&scoped=true"
import script from "./outbound.vue?vue&type=script&lang=js"
export * from "./outbound.vue?vue&type=script&lang=js"
import style0 from "./outbound.vue?vue&type=style&index=0&id=e8bd6ece&lang=scss"
import style1 from "./outbound.vue?vue&type=style&index=1&id=e8bd6ece&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bd6ece",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8bd6ece')) {
      api.createRecord('e8bd6ece', component.options)
    } else {
      api.reload('e8bd6ece', component.options)
    }
    module.hot.accept("./outbound.vue?vue&type=template&id=e8bd6ece&scoped=true", function () {
      api.rerender('e8bd6ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/call/page/outbound.vue"
export default component.exports